import { render, staticRenderFns } from "./ctrl_rule.vue?vue&type=template&id=65d7c7e6&scoped=true&"
import script from "./ctrl_rule.vue?vue&type=script&lang=js&"
export * from "./ctrl_rule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d7c7e6",
  null
  
)

export default component.exports